import { useRouter } from '@application/utils';
import {
  MtFormButtons,
  MtFormContainer,
  MtLayouTitleEditButton,
  MtLayouTitleEditButtonContainer,
  MtLayoutTitleWrapper,
  SectionTitle,
} from '@presentation/components';
import { Form, useFormikContext } from 'formik';
import type { FC } from 'react';
import { FaEdit, FaExternalLinkAlt } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import { PublicProfile } from './components/PublicProfile';
import { PrivateProfile } from './components/PrivateProfile';
import type { MtProfileBreederPageProps, MtProfileBreederValues } from './types';

export * from './types';

export const MtProfileBreederPage: FC<MtProfileBreederPageProps> = (props) => {
  const { mode, onCancelClick, onEditClick, onSubmitForm, loading = false, link } = props;
  const { translate } = useRouter();
  const { resetForm } = useFormikContext<MtProfileBreederValues>();
  return (
    <MtFormContainer>
      <MtLayoutTitleWrapper>
        <SectionTitle>{translate('mt.breeder.onboarding.title.publicPage')}</SectionTitle>
        <MtLayouTitleEditButtonContainer>
          {mode === 'view' && (
            <MtLayouTitleEditButton onClick={onEditClick}>
              <span>{translate('common.buttons.edit')}</span>
              <FaEdit />
            </MtLayouTitleEditButton>
          )}
          {link ? (
            <Link target="_blank" to={link}>
              <MtLayouTitleEditButton color="medium">
                <span>{translate('common.buttons.seeOnTipaw')}</span>
                <FaExternalLinkAlt />
              </MtLayouTitleEditButton>
            </Link>
          ) : null}
        </MtLayouTitleEditButtonContainer>
      </MtLayoutTitleWrapper>

      <Form>
        <PrivateProfile {...props} />
        <PublicProfile {...props} />
        <MtFormButtons
          sticky
          nextLoading={loading}
          submitLoading={loading}
          showPrevious={false}
          showNext={false}
          showCancel={mode === 'edit'}
          showSubmit={mode === 'edit'}
          onSubmitClick={() => onSubmitForm()}
          onCancelClick={(e) => {
            resetForm();
            onCancelClick?.(e);
          }}
        />
      </Form>
    </MtFormContainer>
  );
};
